var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFlechaElevva(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.871,
    height: 49.738,
    viewBox: "0 0 28.871 49.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1541.871 -277.716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1058.087,752.1l-14.407-18.713-14.4,18.713-.029.042h8.006l6.564,19.593,6.454-19.593h7.848Z",
    transform: "translate(512.625 -455.672)",
    fill: "#808ff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.506,1252.232h-9.178l1.448,3.885h6.281Z",
    transform: "translate(412.27 -928.663)",
    fill: "#10232b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFlechaElevva);
export default __webpack_public_path__ + "static/media/ICO-FLECHA-ELEVVA.f1548c4412c6f5a8754231d4c0df9681.svg";
export { ForwardRef as ReactComponent };